import React from "react";
import { observer } from "mobx-react";
import { UserCreateStore } from "../../store";
import { UserCreateForm } from "./UserCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { Language } from "../../../../api/graphql";
import { IdCardType } from "../../../../api/graphql";
import { Gender } from "../../../../api/graphql";

export type UserCreateProps = {
  userCreateStore: UserCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserCreate: React.FC<UserCreateProps> = observer(
  ({ userCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={userCreateStore.isSaving} />
        <UserCreateForm
          userCreateStore={userCreateStore}
          nameError={userCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            userCreateStore.setNameValue(value);
          }}
          name={userCreateStore.entityValues.name}
          emailError={userCreateStore.errors.email?.message}
          onEmailChange={(value: string) => {
            userCreateStore.setEmailValue(value);
          }}
          email={userCreateStore.entityValues.email}
          roleError={userCreateStore.errors.role?.message}
          onRoleChange={(value) => {
            userCreateStore.setRoleValue(value);
          }}
          roleSelectedValue={userCreateStore.entityValues.showRole}
          onRoleSelected={(value) => {
            userCreateStore.setSelectedRole(value);
          }}
          roleOptions={userCreateStore.getRoleOptions()}
          languageError={userCreateStore.errors.language?.message}
          languageOptions={userCreateStore.getLanguageOptions()}
          onLanguageChange={(value: Language) => {
            userCreateStore.setLanguageValue(value);
          }}
          language={userCreateStore.entityValues.language}
          onAvatarChange={(blob: Blob) =>
            userCreateStore.avatarUploadBlob(blob)
          }
          onAvatarDelete={() => userCreateStore.avatarDelete()}
          targetTenantError={userCreateStore.errors.targetTenant?.message}
          onTargetTenantChange={(value) => {
            userCreateStore.setTargetTenantValue(value);
          }}
          targetTenantSelectedValue={
            userCreateStore.entityValues.showTargetTenant
          }
          onTargetTenantSelected={(value) => {
            userCreateStore.setSelectedTargetTenant(value);
          }}
          targetTenantOptions={userCreateStore.getTargetTenantOptions()}
          activeError={userCreateStore.errors.active?.message}
          onActiveChange={(value: boolean) => {
            userCreateStore.setActiveValue(value);
          }}
          active={userCreateStore.entityValues.active}
          cellphoneError={userCreateStore.errors.cellphone?.message}
          onCellphoneChange={(value: string) => {
            userCreateStore.setCellphoneValue(value);
          }}
          cellphone={userCreateStore.entityValues.cellphone}
          twoFaseAuthError={userCreateStore.errors.twoFaseAuth?.message}
          onTwoFaseAuthChange={(value: boolean) => {
            userCreateStore.setTwoFaseAuthValue(value);
          }}
          twoFaseAuth={userCreateStore.entityValues.twoFaseAuth}
          idCardTypeError={userCreateStore.errors.idCardType?.message}
          idCardTypeOptions={userCreateStore.getIdCardTypeOptions()}
          onIdCardTypeChange={(value: IdCardType | "") => {
            userCreateStore.setIdCardTypeValue(value);
          }}
          idCardType={userCreateStore.entityValues.idCardType}
          idCardError={userCreateStore.errors.idCard?.message}
          onIdCardChange={(value: string) => {
            userCreateStore.setIdCardValue(value);
          }}
          idCard={userCreateStore.entityValues.idCard}
          genderError={userCreateStore.errors.gender?.message}
          genderOptions={userCreateStore.getGenderOptions()}
          onGenderChange={(value: Gender | "") => {
            userCreateStore.setGenderValue(value);
          }}
          gender={userCreateStore.entityValues.gender}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={userCreateStore.isProcessing}
          onSave={() => userCreateStore.saveNewUser()}
          onCancel={() => userCreateStore.cancelNewUser()}
        />
        <ErrorDialog
          open={userCreateStore.errorDialogOpened}
          title={userCreateStore.errorTitle}
          description={userCreateStore.errorDescription}
          onClose={() => userCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
